export interface SurveyErrorCode {
  errCode: string;
  stepNum: number;
  questionNum: number;
  questionCount: number;
}
